<template lang="pug">
  yz-dialog(v-model="showDialog" persistent scrollable max-width="500px")
    yz-card
      yz-dialog-normal-header(title="Set admin fee" @close="onCancel")
      yz-dialog-normal-content.pa-6
        .text-neutral-700
          .yz-regular-body-sm.mb-4
            div This admin fee will be applied to all selected documents.
            div You can still edit each one individually later.

          .yz-medium-body-sm.mb-1 Admin fee
          .d-flex.align-center(style="gap: 4px")
            yz-dropdown.flex-grow-1(v-model="feeType" :items="feeTypeOptions" size="md")
            yz-text-field.flex-grow-1(v-model.number="feeValue" type="number" size="md" :prefix="feeType === 'fixed' ? 'RM' : ''" :suffix="feeType === 'percentage' ? '%' : ''" :rules="adminFeeRules" required required-error-message="Admin fee is required" min="0")
      yz-dialog-normal-actions
        yz-btn(size="lg" text label="Cancel" @click="onCancel")
        yz-tooltip(v-if="!canSave" :text="saveButtonTooltip" direction="left")
          yz-btn(size="lg" label="Apply to all" :disabled="!canSave" @click="onConfirm")
        yz-btn(v-else size="lg" label="Apply to all" @click="onConfirm")
</template>

<script>
import { validateDecimalPlaces } from '@/utils'

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      feeType: 'fixed',
      feeValue: 0,
      feeTypeOptions: [
        { text: 'Fixed', value: 'fixed' },
        { text: 'Percentage', value: 'percentage' }
      ]
    }
  },
  computed: {
    showDialog: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    adminFeeRules() {
      if (this.feeType === 'percentage') {
        // Percentage rules
        return [
          v => (v !== null && v !== '') || 'Admin fee is required',
          v => v === null || v === '' || (v >= 0 && v <= 100) || 'Percentage must be between 0 and 100',
          v => v === null || v === '' || Number.isInteger(Number(v)) || 'Percentage must be integer'
        ]
      } else {
        // Fixed amount rules
        return [
          v => (v !== null && v !== '') || 'Admin fee is required',
          v => v === null || v === '' || v >= 0 || 'Admin fee cannot be negative',
          v => validateDecimalPlaces(v, this.$currency)
        ]
      }
    },
    canSave() {
      const value = this.feeValue
      return this.adminFeeRules.every(rule => rule(value) === true)
    },
    saveButtonTooltip() {
      if (this.canSave) return ''

      const value = this.feeValue
      const failedRules = this.adminFeeRules.filter(rule => rule(value) !== true)

      if (failedRules.length > 0) {
        return failedRules[0](value)
      }

      return ''
    }
  },
  methods: {
    onConfirm() {
      if (!this.canSave) {
        return
      }

      this.$emit('confirmed', {
        feeType: this.feeType,
        feeValue: Number(this.feeValue)
      })
      this.showDialog = false
    },
    onCancel() {
      this.$emit('canceled')
      this.showDialog = false
    }
  }
}
</script>

<style scoped></style>
